module.exports = __webpack_public_path__ + "img/bell-white.3f61cf0f.svg";